import request from "@/router/axios";
export const get = (id) => {
  return request({
    url: `/api/bed/record/get`,
    method: "get",
    params: {
      id,
    },
  });
};
export const loadRecordsOfWardDay = (wardId, day) => {
  return request({
    url: `/api/bed/record/loadRecordsOfWardDay`,
    method: "get",
    params: {
      wardId,
      day,
    },
  });
};

export const inpatient = (recordId) => {
  return request({
    url: `/api/bed/record/inpatient`,
    method: "post",
    params: {
      recordId,
    },
  });
};

export const getRecordLogs = (recordId) => {
  return request({
    url: `/api/bed/record/getRecordLogs`,
    method: "get",
    params: {
      recordId,
    },
  });
};

export const summary = (start, end) => {
  return request({
    url: `/api/bed/record/summary`,
    method: "get",
    params: {
      start,
      end,
    },
  });
};
export const adjust = (recordId, wardGroupId) => {
  return request({
    url: `/api/bed/record/adjust`,
    method: "post",
    params: {
      recordId,
      wardGroupId,
    },
  });
};
export const againSend = (recordId, eventType) => {
  return request({
    url: `/api/bed/record/againSend`,
    method: "post",
    params: {
      recordId,
      eventType,
    },
  });
};
export const editInlineRemark = (recordId, inlineRemark) => {
  return request({
    url: `/api/bed/record/editInlineRemark`,
    method: "post",
    params: {
      recordId,
      inlineRemark,
    },
  });
};